import React from "react";
import { Link } from "react-router-dom";

import { TILES } from "./tiles";
import { tileValue } from "./tileValue";

export default function TopComponent({ name, totalCount }) {
  const { to, Icon } = TILES[name] || {};

  const body = (
    <>
      {Icon ? (
        <span className="dash-kpi-icon" aria-hidden="true">
          <Icon />
        </span>
      ) : null}
      <span className="dash-kpi-title">{name}</span>
      <span className="dash-kpi-num">{tileValue(totalCount)}</span>
    </>
  );

  if (!to) {
    return <div className="dash-kpi-tile">{body}</div>;
  }

  return (
    <Link to={to} className="dash-kpi-tile dash-kpi-tile--link">
      {body}
    </Link>
  );
}
